import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  shortcutContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(0, 2),
    transition: 'all 0.3s ease',
    border: `2px solid transparent`,
    marginBottom: theme.spacing(2),
    '&:hover': {
      borderColor: theme.palette.hover2,
    }
  },
  descriptionText: {
    display: 'box',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    lineClamp: 5,
    boxOrient: 'vertical',
    wordBreak: 'break-all',
    maxHeight: 'fit-content',
  },
  titleContainer:{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    padding: theme.spacing(1, 0),
  },
  info: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    padding: 15,
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.hover2}`,
    marginBottom: 15,
  },
  add: {
    cursor: 'pointer',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 15,
    marginTop: 15,
    marginBottom: 15,
    borderRadius: theme.shape.borderRadius,
    border: `1px dashed ${theme.palette.hover2}`,
    backgroundColor: theme.palette.hover,
    '& > * ': {
      color: theme.palette.primary.main,
    },
    transition: 'all 200ms ease-in-out',
    '&:hover': {
      border: `1px dashed ${theme.palette.hover2}`,
      backgroundColor: theme.palette.hover2,
    },
  },
  shortcutContent: {
    width: '100%',
    display: 'flex',
    cursor: 'pointer',
    justifyContent: 'space-between',
    marginTop: 15,
    borderRadius: theme.shape.borderRadius,
    '& > * ': {
      flexGrow: 0,
      overflowWrap: 'anywhere',
      whiteSpace: 'pre-wrap',
    },
    '& h6 ': {
      fontSize: theme.typography.fontSize,
      marginBottom: 5,
    },
  },
  contentIcons: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    '& * ': {
      color: theme.palette.primary.main,
    },
  },
  emptySpace: {
    width: '100vw',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
}))

export default useStyles
